import { render, staticRenderFns } from "./blog-post-card3.vue?vue&type=template&id=387ba884&scoped=true"
import script from "./blog-post-card3.vue?vue&type=script&lang=js"
export * from "./blog-post-card3.vue?vue&type=script&lang=js"
import style0 from "./blog-post-card3.vue?vue&type=style&index=0&id=387ba884&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387ba884",
  null
  
)

export default component.exports